import { handleSPOE } from "../Functions"
    

export const serviceCoordinatorColumns = (getColumnSearchProps) => [
    {
        title: 'Preferred Name',
        dataIndex: 'preferredName',
        key: 'preferredName',
        ...getColumnSearchProps('preferredName'),
        sorter: (a, b) => a.preferredName.localeCompare(b.preferredName),
        sortDirections: [`ascend`, `descend`]
    },
    {
        title: 'Last Name',
        dataIndex: 'lastName',
        key: 'lastName',
        ...getColumnSearchProps('lastName'),
        sorter: (a, b) => a.lastName.localeCompare(b.lastName),
        sortDirections: [`ascend`, `descend`]
    },
    {
        title: 'SPOE',
        dataIndex: 'spoe',
        key: 'spoe',
        render: handleSPOE,
        ...getColumnSearchProps('spoe'),
        sorter: (a, b) => a.spoe.localeCompare(b.spoe),
        sortDirections: [`ascend`, `descend`]
    }
]

export const therapistColumns = (getColumnSearchProps) => [
    {
        title: 'Preferred Name',
        dataIndex: 'preferredName',
        key: 'preferredName',
        ...getColumnSearchProps('preferredName'),
        sorter: (a, b) => a.preferredName.localeCompare(b.preferredName),
        sortDirections: [`ascend`, `descend`]
    },
    {
        title: 'Last Name',
        dataIndex: 'lastName',
        key: 'lastName',
        ...getColumnSearchProps('lastName'),
        sorter: (a, b) => a.lastName.localeCompare(b.lastName),
        sortDirections: [`ascend`, `descend`]
    },
    {
        title: 'City',
        dataIndex: 'city',
        key: 'city',
        ...getColumnSearchProps('city'),
        sorter: (a, b) => {
            const aCity = a.city || '';
            const bCity = b.city || '';
            return aCity.localeCompare(bCity);
        },
        sortDirections: [`ascend`, `descend`]
    }
]

export const edTeamColumns = (getColumnSearchProps) => [
    {
        title: 'Preferred Name',
        dataIndex: 'preferredName',
        key: 'preferredName',
        ...getColumnSearchProps('preferredName'),
        sorter: (a, b) => a.preferredName.localeCompare(b.preferredName),
        sortDirections: [`ascend`, `descend`]
    },
    {
        title: 'Last Name',
        dataIndex: 'lastName',
        key: 'lastName',
        ...getColumnSearchProps('lastName'),
        sorter: (a, b) => a.lastName.localeCompare(b.lastName),
        sortDirections: [`ascend`, `descend`]
    },
    {
        title: 'Email Address',
        dataIndex: 'emailAddress',
        key: 'emailAddress',
        ...getColumnSearchProps('emailAddress'),
        sorter: (a, b) => {
            const aCity = a.emailAddress || '';
            const bCity = b.emailAddress || '';
            return aCity.localeCompare(bCity);
        },
        sortDirections: [`ascend`, `descend`]
    }
]

export const developmentalTherapistColumns = (getColumnSearchProps) => [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        ...getColumnSearchProps('name'),
        sorter: (a, b) => a.name.localeCompare(b.name),
        sortDirections: [`ascend`, `descend`]
    },
    {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
        ...getColumnSearchProps('address'),
        sorter: (a, b) => a.address.localeCompare(b.address),
        sortDirections: [`ascend`, `descend`]
    },
]

export const occupationalTherapistColumns = (getColumnSearchProps) => [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        ...getColumnSearchProps('name'),
        sorter: (a, b) => a.name.localeCompare(b.name),
        sortDirections: [`ascend`, `descend`]
    },
    {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
        ...getColumnSearchProps('address'),
        sorter: (a, b) => a.address.localeCompare(b.address),
        sortDirections: [`ascend`, `descend`]
    },
]

export const physicalTherapistColumns = (getColumnSearchProps) => [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        ...getColumnSearchProps('name'),
        sorter: (a, b) => a.name.localeCompare(b.name),
        sortDirections: [`ascend`, `descend`]
    },
    {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
        ...getColumnSearchProps('address'),
        sorter: (a, b) => a.address.localeCompare(b.address),
        sortDirections: [`ascend`, `descend`]
    },
]

export const speechTherapistColumns = (getColumnSearchProps) => [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        ...getColumnSearchProps('name'),
        sorter: (a, b) => a.name.localeCompare(b.name),
        sortDirections: [`ascend`, `descend`]
    },
    {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
        ...getColumnSearchProps('address'),
        sorter: (a, b) => a.address.localeCompare(b.address),
        sortDirections: [`ascend`, `descend`]
    },
]